var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0009 12.7205L12.0009 11.7207C12.0009 11.1903 11.7902 10.6817 11.4152 10.3067C11.0401 9.93163 10.5315 9.72095 10.0011 9.72095L6.00168 9.72095C5.47132 9.72095 4.96268 9.93163 4.58766 10.3067C4.21264 10.6817 4.00195 11.1903 4.00195 11.7207L4.00195 12.7205",
    stroke: "#2F3139",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00168 7.72123C9.1061 7.72123 10.0014 6.82592 10.0014 5.7215C10.0014 4.61708 9.1061 3.72177 8.00168 3.72177C6.89726 3.72177 6.00195 4.61708 6.00195 5.7215C6.00195 6.82592 6.89726 7.72123 8.00168 7.72123Z",
    stroke: "#2F3139",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.750977,
    y: 0.749115,
    width: 14.5,
    height: 14.5,
    rx: 1.25,
    stroke: "#2F3139",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser2);
export default __webpack_public_path__ + "static/media/user-2.6e460b472da112e877065a6d7b567e30.svg";
export { ForwardRef as ReactComponent };